import type { BlokFetcherProps, BlokProps } from "@trydig/storyblok";
import { rpc } from "#rpc";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { renderRichText } from "@/components/bloks/utils";
import { ExplorationProductInContent } from "@/components/ui/sections/ExplorationProductInContent";
import type { ProductsRoute } from "@/data/routes/products.route";
import type { ExplorationProductInContentStoryblok } from "@/generated/sb/sb-types";
import { sbLink } from "@/lib/storyblok/link";
import { checkBlokBackground } from "@/lib/utils/isDarkMode";

const clampLimit = (raw: string | number | undefined) => {
	const n = typeof raw === "number" ? raw : Number(raw ?? 4);
	if (!Number.isFinite(n) || n < 1) return 4;
	return Math.min(12, Math.floor(n));
};

export const explorationProductInContentFetcher = async ({
	blok,
}: BlokFetcherProps<ExplorationProductInContentStoryblok>) => {
	return rpc.products.exploration({
		ids: blok.products,
		categoryId: blok.centraCategory,
		limit: clampLimit(blok.productLimit),
	});
};

export const explorationProductInContentKey = ({
	blok,
}: BlokFetcherProps<ExplorationProductInContentStoryblok>) => [
	...(blok.products ?? []),
	blok.centraCategory ?? "",
	String(blok.productLimit ?? 4),
];

export const ExplorationProductInContentBlok = ({
	blok,
	data,
}: BlokProps<ExplorationProductInContentStoryblok, ProductsRoute["exploration"]>) => {
	const linkHref = sbLink(blok.link)?.href;
	const bg = checkBlokBackground(blok);

	return (
		<BlokWrap editable={blok} asChild>
			<ExplorationProductInContent
				heading={blok.heading || undefined}
				linkLabel={blok.linkLabel || undefined}
				linkHref={linkHref}
				bodyText={renderRichText(blok.bodyText)}
				products={data?.products ?? []}
				bg={bg}
			/>
		</BlokWrap>
	);
};
